import type { TeamRole as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * The role as the list screens and the user-account role picker read it. The details view has
 * its own, much wider type — see `TeamRoleDetails`.
 */
export type TeamRole = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): TeamRole =>
  take(item, 'id', 'name') as TeamRole;
